export default __webpack_public_path__ + "static/media/about1.f8704c01.jpg";